import { useState, useEffect } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';
import { useGetAccountSchema } from '../services/SchemaService';
import { OtpRequestChannelType } from '../_types/otp.types';
import { AUTH_TYPES, Schema, SIGNUP_TYPES } from '../_types/schema.types';

interface AuthFlowState {
  isOpenFlow: boolean;
  isOtpAuth: boolean;
  signupType: string;
  authType: string;
  schemaId: string | null;
  otpRequestChannelType: OtpRequestChannelType;
}

export const useSchema = () => {
  const { data: schemaData } = useGetAccountSchema();
  const [authFlow, setAuthFlow] = useState<AuthFlowState>(() => {
    const initialSchemaData: Schema | null = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);

    const signupType = initialSchemaData?.signupType || SIGNUP_TYPES.OPEN;
    const authType = initialSchemaData?.authenticationType?.toLowerCase() || AUTH_TYPES.PASSWORD.toLowerCase();
    const otpRequestChannelType = initialSchemaData?.otpRequestChannelType || 'All';

    console.log('useSchema - Initial schemaData:', initialSchemaData);
    console.log('useSchema - Initial signupType:', signupType);
    console.log('useSchema - Initial isOpenFlow:', signupType === SIGNUP_TYPES.OPEN);

    return {
      isOpenFlow: signupType === SIGNUP_TYPES.OPEN,
      isOtpAuth: authType === AUTH_TYPES.OTP.toLowerCase(),
      signupType,
      authType,
      schemaId: initialSchemaData?.id || null,
      otpRequestChannelType
    };
  });

  // Atualizar o estado quando o schema mudar
  useEffect(() => {
    if (schemaData) {
      const signupType = schemaData?.signupType || SIGNUP_TYPES.OPEN;
      const authType = schemaData?.authenticationType?.toLowerCase() || AUTH_TYPES.PASSWORD.toLowerCase();
      const otpRequestChannelType = schemaData?.otpRequestChannelType || 'All';

      setAuthFlow({
        isOpenFlow: signupType === SIGNUP_TYPES.OPEN,
        isOtpAuth: authType === AUTH_TYPES.OTP.toLowerCase(),
        signupType,
        authType,
        schemaId: schemaData?.id || null,
        otpRequestChannelType
      });
    } else {
      // Log quando não há schemaData
      const localStorageSchema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      console.log('useSchema - localStorage schema:', localStorageSchema);
    }
  }, [schemaData]);

  const checkIsOpenFlow = (): boolean => {
    return authFlow.isOpenFlow;
  };
  const checkIsOtpAuth = (): boolean => authFlow.isOtpAuth;
  const checkIsPasswordAuth = (): boolean => authFlow.authType === AUTH_TYPES.PASSWORD.toLowerCase();

  const getAuthenticationType = () => authFlow.authType;
  const getSchemaId = () => authFlow.schemaId;
  const getValidationChannelType = (): OtpRequestChannelType => authFlow.otpRequestChannelType;

  // Método para obter o schema completo (útil para outros casos)
  const getSchema = (): Schema | null => ApiLocalStorage.get(SCHEMA_STORAGE_KEY);

  return {
    ...authFlow,
    checkIsOpenFlow,
    checkIsOtpAuth,
    checkIsPasswordAuth,
    getAuthenticationType,
    getSchemaId,
    getValidationChannelType,
    getSchema
  };
}
 